import { render, staticRenderFns } from "./wonChallenge.vue?vue&type=template&id=a64c86b2&scoped=true&"
import script from "./wonChallenge.vue?vue&type=script&lang=js&"
export * from "./wonChallenge.vue?vue&type=script&lang=js&"
import style0 from "./wonChallenge.vue?vue&type=style&index=0&id=a64c86b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c86b2",
  null
  
)

export default component.exports